import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appSortcode]',
})
export class SortcodeDirective {
  @HostListener('input', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    let trimmed: string = input.value.replace(/-+/g, '');
    if (trimmed.length > 6) {
      trimmed = trimmed.substr(0, 6);
    }

    const numbers: Array<string> = [];
    for (let i = 0; i < trimmed.length; i += 2) {
      numbers.push(trimmed.substr(i, 2));
    }
    input.value = numbers.join('-');
  }
}
